import {
  UserBet,
  CURRENCY_TYPE_FACTOR,
  getCurrencyTypeFromToken,
  useAppDispatch,
  defaultFilters,
  RootState,
  fetchMyBets,
  useAppSelector,
  getAllMarketsByEvent,
  getSecondaryMarketsByEvent,
  getPremiumMarkets,
  getSecondaryMatchOddsByEvent,
  fetchOpenBets,
  BFToSRIdMap,
  setIsOneClickBettingEnabled,
  isBackOnlyMarket,
  isBmSpecialMarket,
} from "@hypexone/uicore";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import TVGames from "../../../assets/images/Casino_svg_img/Tv.svg";
import LiveStream from "../all-markets/LiveStream";
import { getUserCreationTime } from "../all-markets/LiveStream";
import StakeSettings from "../user-menu-pages/StakeSettings";
import { useLocation } from "react-router-dom";
import CheckboxComponent from "../shared/CheckboxComponent";

type OpenBetsProps = {
  openBets: UserBet[];
  bets: any;
  pageType?: string;
  premiumMarkets: any;
  secondaryMarkets: any;
};

const getDisplayName = (runnerName: string) => {
  let name =
    runnerName.split(":").length > 1
      ? runnerName.split(":")[1]
      : runnerName.split(":")[0];
  if (name.toLowerCase().includes("crudeoil")) return "CRUDE OIL";
  else if (name.toLowerCase().includes("gold")) return "GOLD";
  else if (name.toLowerCase().includes("silver")) return "SILVER";
  else if (name.toLowerCase().includes("banknifty")) return "BANK NIFTY";
  return name;
};
const OpenBetsTab: React.FC<OpenBetsProps> = (props) => {
  const { openBets, bets, pageType, premiumMarkets, secondaryMarkets } = props;
  const { isOneClickBettingEnabled } = useAppSelector((state) => state.betSlip);
  const { langData } = useAppSelector((state) => state.cms);


  const [showLiveStream, setShowLiveStream] = useState<boolean>(false);
  const { loggedIn, balanceSummary } = useAppSelector((state: RootState) => state.auth);
  const [backupStreamUrl, setBackupStreamUrl] = useState<string>(null);
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];
  const dispatch = useAppDispatch();
  const [scorecardID, setScorecardID] = useState<string>("");
  const location = useLocation();
  const message = location.state?.message;

  const { events, selectedEventType, selectedCompetition, selectedEvent } =
    useAppSelector((state) => state.catalog);

  const eventData = getAllMarketsByEvent(
    events,
    selectedEventType?.id,
    selectedCompetition?.id,
    selectedEvent?.id
  );

  const displayBalance = (balanceSummary?.balance ?? 0) / (cFactor || 1);
  const oct12025 = new Date("2025-10-01T00:00:00Z").getTime() / 1000;
  const userCreatedBeforeOct1_2025 = (() => {
    const ctime = getUserCreationTime();
    if (ctime == null) return false;
    return ctime < oct12025;
  })();
  const userCreatedOnOrAfterOct1_2025 = !userCreatedBeforeOct1_2025;
  const LIVE_STREAM_RESTRICTED_COMPETITION_ID = "12674623";
  const hideLiveStream =
    eventData?.competitionId === LIVE_STREAM_RESTRICTED_COMPETITION_ID &&
    (userCreatedOnOrAfterOct1_2025 || displayBalance <= 1000);

  const handleToggleScorecard = () => {
    setShowLiveStream(!showLiveStream);
  };

  useEffect(() => {
    return () => {
      setScorecardID("");
    };
  }, []);

  useEffect(() => {
    if (loggedIn && eventData?.eventId) {
      let sid = selectedEvent?.id.includes("_")
        ? BFToSRIdMap[selectedEventType?.id]
        : selectedEventType?.id;
      dispatch(fetchOpenBets({ eventId: selectedEvent?.id, sportId: sid }));
    }
  }, []);

  useEffect(() => {
    if (
      loggedIn &&
      eventData?.eventId &&
      scorecardID === "" &&
      eventData?.providerName?.toLowerCase() === "sportradar"
    ) {
      if (eventData?.eventId?.includes("_")) {
        setScorecardID(eventData?.eventId?.split("_")[2]);
      } else {
        setScorecardID(eventData?.eventId?.split(":")[2]);
      }
    }
  }, [eventData?.providerName]);

  const getBetDisplayName = (bet: UserBet) => {
    switch (bet.marketType) {
      // TODO: remove binary
      case "FANCY":
      case "BINARY":
        const isOddEvenFancyDisplay =
          bet.marketType === 'FANCY' &&
          (bet?.oddType === 'ODD_EVEN' ||
            bet.marketName?.includes('Odd Even Run Bhav'));
        return (
          (bet.marketType === 'BINARY'
            ? getDisplayName(bet.outcomeDesc) +
            ' @ ' +
            Number(bet.oddValue * 100 - 100).toFixed(0)
            : isOddEvenFancyDisplay
              ? `${bet.marketName} - ${bet.outcomeDesc}`
              : bet.marketName +
              ' @ ' +
              Number(bet.oddValue * 100 - 100).toFixed(0))
        );
      case "BOOKMAKER":
        return `${
          bet.marketName.toLowerCase().includes("toss") || isBackOnlyMarket(bet.oddType, bet.marketName)
            ? bet.oddType === 'BACK_ONLY_ODDS'
              ? bet.marketName
              :  "Toss" : "BM"
        } - ${bet.outcomeDesc}`;
      case "MATCH_ODDS":
        if (bet.marketName === "Completed Match") {
          return "Completed Match - " + bet.outcomeDesc;
        } else if (bet.marketName === "Tied Match") {
          return "Tied Match - " + bet.outcomeDesc;
        } else {
          return "MO - " + bet.outcomeDesc;
        }
      default:
        return bet.marketName + " - " + bet.outcomeDesc;
    }
  };
  
  const getBetOddValue = (bet: UserBet) => {
    return bet.marketType === "FANCY" || bet.marketType === "BINARY"
      ? Number(bet.sessionRuns).toFixed(0)
      : bet.marketType === "BOOKMAKER"
      ? isBmSpecialMarket(bet.marketName, bet.oddType) ? Number(bet.oddValue).toFixed(2) : Number(bet.oddValue * 100 - 100).toFixed(2)
      : Number(bet.oddValue);
  };

  const getBetStakeAmount = (bet: UserBet) =>
    Number(bet.stakeAmount / cFactor).toFixed(2);

  return (
    <div className="top-0 z-50 ">
      {message && (
        <div
          className={`transition-all duration-700 ease-in-out overflow-hidden transform ${
            message
              ? "opacity-100 translate-y-0 max-h-[1000px] scale-100 pointer-events-auto"
              : "opacity-0 -translate-y-5 max-h-0 scale-95 pointer-events-none"
          }`}
        >
          <StakeSettings />
        </div>
      )}
      {/*       {eventData?.eventId && !eventData?.virtualEvent && showLiveStream && !hideLiveStream && (
        <LiveStream
          competitionId={eventData?.competitionId}
          eventID={
            eventData?.sportId === "99994"
              ? secondaryMarkets?.bookmakers?.length > 0
                ? eventData.eventId
                : "sr:match:" + scorecardID
              : eventData?.matchOdds?.runners?.length === 0 &&
                secondaryMarkets?.bookmakers?.length > 0 &&
                premiumMarkets?.markets?.matchOdds.length > 0
              ? "sr:match:" + scorecardID
              : eventData.eventId
          }
          providerUrl={backupStreamUrl}
        />
      )} */}

      {/* One click betting enabled Desktop */}
      <div className="bg-blue4 p-2 mb-1 text-white">
        <div className="w-fit">
          <CheckboxComponent
            checked={isOneClickBettingEnabled}
            onChange={() => dispatch(setIsOneClickBettingEnabled(!isOneClickBettingEnabled))}
            label={langData?.["one_click_betting_enabled"] || "One Click Betting Enabled"}
          />
        </div>
      </div>

      <div className="bg-blue4 flex justify-between items-center px-[2px] py-[2px] text-white text-sm">
        <div className="text-[12px]">Open Bets</div>
        {!hideLiveStream && (
          <div onClick={handleToggleScorecard} className="cursor-pointer">
            <img src={TVGames} className="w-4 h-4 invert" />
          </div>
        )}
      </div>

      {openBets?.length > 0 ? (
        <table className="text-black w-full text-[14px]">
          <thead>
            <tr className="text-[#000] bg-neutral-200 text-[14px] font-medium h-[30px]">
              <th className="border-r text-[11px] border-[#e0e0e0] text-left pl-2">
                Market
              </th>
              <th className="border-r text-[11px] border-[#e0e0e0] text-left pl-2">
                Odds
              </th>
              <th className="border-r text-[11px] border-[#e0e0e0] text-left pl-2">
                Stake
              </th>
            </tr>
          </thead>
          <tbody>
            {openBets?.map((bet, idx) => (
              <tr
                key={"row" + bet?.betId}
                className={`h-[30px] border-b-[1px] text-[11px] ${
                  bet.betType === "BACK"
                    ? "bg-blue-400 bg-opacity-60"
                    : "bg-pink1 bg-opacity-60"
                }`}
              >
                <td className="pl-2" key={"cell" + bet?.betId + idx}>
                  {getBetDisplayName(bet)}
                </td>
                <td className="pl-2" key={"cell" + bet?.betId + idx}>
                  {getBetOddValue(bet)}
                </td>
                <td className="pl-2" key={"cell" + bet?.betId + idx}>
                  {getBetStakeAmount(bet)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="flex items-center justify-center text-[14px] text-[#757575] bg-neutral-200 h-full pt-7 pb-6">
          Place bet to see it here.
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  const selectedEvent = state.catalog.selectedEvent;
  const event = state.catalog.selectedEvent;
  return {
    openBets: state.betSlip.openBets,
    bets: state.report.bets,
    premiumMarkets: getPremiumMarkets(
      state.catalog.premiumMarketsMap,
      event.id
    ),
    secondaryMarkets: getSecondaryMarketsByEvent(
      state.catalog.secondaryMarketsMap,
      selectedEvent?.id
    ),
  };
};

export default connect(mapStateToProps, null)(OpenBetsTab);
